import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { numberToHebrewLetter } from "../lib/hebrewNumerals";
import { talmudDafLabel, talmudDafLabelEn } from "../lib/hebrewRef";

export default function ChapterPicker({ open, onClose, book, currentChapter, onSelect }) {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === "en";
  const dir = isEn ? "ltr" : "rtl";
  const total = book?.chapters || 0;
  const isTalmud = book?.kind === "talmud";
  // Book name in the dialog title: use EN name (e.g. "Genesis") when
  // the UI is English, Hebrew otherwise. `book.en` is already supplied
  // by the BE for every covered book.
  const bookLabel = isEn ? (book?.en || book?.he) : book?.he;
  const headingSuffix = isTalmud
    ? t("chapter_picker.title_daf")
    : t("chapter_picker.title_chapter");
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        dir={dir}
        className="max-w-2xl bg-background border-gold/30"
        data-testid="chapter-picker"
      >
        <DialogHeader>
          <DialogTitle className={`font-heading text-2xl text-foreground ${isEn ? "text-left" : "text-right"}`}>
            {bookLabel} · {headingSuffix}
          </DialogTitle>
          <div className="ornamental-divider">✦</div>
        </DialogHeader>
        <div
          className={`grid ${isTalmud ? "grid-cols-4 sm:grid-cols-6 md:grid-cols-8" : "grid-cols-6 sm:grid-cols-8 md:grid-cols-10"} gap-2 max-h-[60vh] overflow-y-auto pt-2`}
          dir={dir}
        >
          {Array.from({ length: total }).map((_, i) => {
            const ch = i + 1;
            const active = ch === currentChapter;
            let label;
            if (isTalmud) {
              // English mode uses arabic-numeral daf labels (e.g. "2a"),
              // Hebrew mode keeps the gematria form ("ב.").
              label = isEn && typeof talmudDafLabelEn === "function"
                ? talmudDafLabelEn(ch)
                : talmudDafLabel(ch);
            } else {
              label = isEn ? String(ch) : numberToHebrewLetter(ch);
            }
            return (
              <button
                key={ch}
                data-testid={`picker-chapter-${ch}`}
                onClick={() => onSelect(ch)}
                className={`${isTalmud ? "py-3 px-2" : "aspect-square"} rounded-sm font-heading text-sm transition-all ${
                  active
                    ? "bg-gold text-parchment border border-gold"
                    : "border border-border/60 text-foreground/80 hover:border-gold/50 hover:bg-gold/10"
                }`}
              >
                {label}
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
